<template>
  <Modal ref="modal" title="Fotos por Aluno" @cancel="close">
    <div class="loading" v-if="!loaded">
      <LoadingSpinner />
    </div>

    <template v-else>
      <form class="relatorio-form" @submit.prevent="handleSubmit">
        <div class="inputs">
          <div class="inputs-row">
            <Select class="input-full" :options="schemaOptions" legend="Autoescola" placeholder="Selecione"
              :modelValue="schema" @update:modelValue="$event => (this.schema = $event)" :disabled="loading" />

            <Select class="input-full" :options="devices" legend="Dispositivo" placeholder="Selecione"
              :modelValue="device" @update:modelValue="$event => (this.device = $event)" :disabled="loading" />

            <Input class="input-full" type="number" :modelValue="agrupamento"
              @update:modelValue="$event => (this.agrupamento = $event)" legend="Agrupamento"
              placeholder="Digite o agrupamento" :disabled="loading" />
          </div>
          <div class="inputs-row">
            <Input class="input-full" :modelValue="aluno" @update:modelValue="$event => (this.aluno = $event)"
              legend="Aluno(a)" placeholder="Digite o nome do aluno(a)" :disabled="loading" />

            <Period legend="Insira o período" :firstModelValue="initialDate" :secondModelValue="finalDate"
              @update:firstModelValue="$event => (this.initialDate = $event)"
              @update:secondModelValue="$event => (this.finalDate = $event)" :disabled="loading" />
          </div>
        </div>

        <div class="buttons">
          <Button type="button" @handle:click="clearInputs" text="Limpar" :fill="false" color="danger"
            :disabled="loading">
            <CloseCircleOutline :size="18" />
          </Button>

          <Button type="submit" text="Consultar" color="primary" :disabled="loading">
            <Magnify :size="18" />
          </Button>
        </div>
      </form>

      <div class="loading" v-if="loading">
        <LoadingSpinner />
      </div>

      <div v-else-if="photos.length > 0 && !loading" class="result-container">
        <div class="actions">
          <Input class="input-full" type="number" :modelValue="paginationData.total" legend="Registro"
            :disabled="loading" :readonly="true" />

          <Button @handle:click="handleExport" text="Gerar planilha" color="primary" :disabled="loadingActions">
            <TrayArrowDown :size="18" />
          </Button>
        </div>

        <div class="table-container">
          <Paginate :total-pages="paginationData.lastPage" :current-page="paginationData.currentPage"
            @page-changed="fetchPhotos" />

          <Table :headers="['Agrupamento', 'CFC', 'Início', 'Fim', 'Nome', 'N° de Fotos', 'Dispositivo']">
            <tr v-for="(photo, index) in photos" :key="index">
              <td>{{ photo.id_agrupamento }}</td>
              <td>{{ photo.schema }}</td>
              <td>{{ utils.formatDate(photo.inicio) }}</td>
              <td>{{ utils.formatDate(photo.fim) }}</td>
              <td>{{ photo.nome }}</td>
              <td>{{ photo.quantidade_fotos }}</td>
              <td>{{ photo.dispositivo }}</td>
            </tr>
          </Table>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from 'core/Modal'
import LoadingSpinner from 'core/LoadingSpinner'
import Select from 'core/Select'
import Period from 'core/Period'
import Input from 'core/Input'
import Button from 'core/Button'
import Table from 'core/Table'
import Paginate from 'core/Paginate'
import TrayArrowDown from 'icons/TrayArrowDown'
import CloseCircleOutline from 'icons/CloseCircleOutline'
import Magnify from 'icons/Magnify'
import _export from '../../../../services/export'
import utils from '../../../../services/utils'

export default {
  name: 'FotosPorAlunoModal',
  components: {
    Modal,
    LoadingSpinner,
    Select,
    Period,
    Input,
    Button,
    Table,
    Paginate,

    TrayArrowDown,
    CloseCircleOutline,
    Magnify,
  },
  data() {
    return {
      utils: utils,
      schema: '',
      initialDate: '',
      finalDate: '',
      aluno: '',
      device: '',
      agrupamento: '',
      paginationData: {
        currentPage: 1,
        lastPage: 0,
        total: 0,
      },
      schemaOptions: [],
      devices: [
        { value: 'Link', text: 'Link' },
        { value: 'Aplicativo', text: 'Aplicativo' },
      ],
      photos: [],
      loaded: false,
      loading: false,
      loadingActions: false,
    }
  },
  methods: {
    async open() {
      this.$refs.modal.open()

      await this.fetchCfcs()

      this.loaded = true
    },
    close() {
      this.$refs.modal.close()

      this.schema = ''
      this.initialDate = ''
      this.finalDate = ''
      this.aluno = ''
      this.device = ''
      this.agrupamento = ''
      this.loaded = false
      this.loading = false
    },
    async fetchCfcs() {
      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/autoescola/todas`)
        .then((res) => {
          this.schemaOptions = res.body.dados
            .filter(cfc => cfc.nome_fantasia !== "TESTE")
            .map(cfc => ({
              value: cfc.tenant_schema,
              text: cfc.nome_fantasia
            }))
        })
        .catch((error) => {
          this.$toasted.show('Erro!' + error.body.mensagem, {
            position: 'top-right',
          })
        })
    },
    async handleSubmit() {
      if (this.validateInputs()) {
        await this.fetchPhotos()
      }
    },
    validateInputs() {
      if ((this.initialDate && !this.finalDate) || (!this.initialDate && this.finalDate)) {
        this.$toasted.show('Ambos os campos de período devem ser preenchidos.', {
          icon: 'fa-times',
          position: 'top-right',
        })
        return false
      }

      if (this.initialDate && this.finalDate) {
        const initial = new Date(this.initialDate)
        const final = new Date(this.finalDate)

        if (final < initial) {
          this.$toasted.show('A data final deve ser maior ou igual à data inicial!', {
            icon: 'fa-times',
            position: 'top-right',
          })
          return false
        }
      }

      return true
    },
    async fetchPhotos(page = 1) {
      this.loading = true

      const params = {
        page,
      }

      if (this.agrupamento) params.agrupamento = this.agrupamento
      if (this.schema) params.cfc = this.schema
      if (this.nome) params.aluno = this.aluno
      if (this.device) params.dispositivo = this.device
      if (this.initialDate && this.finalDate) {
        params.periodo = [this.initialDate, this.finalDate]
      }

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/aulas/teoricas/monitoramento/fotos/consultar/filtros`, {
        params,
      })
        .then((res) => {
          const result = res.body.dados

          if (!result.data.length) {
            this.$toasted.show('Sem resultados para sua pesquisa.', {
              position: 'top-right',
            })
          }

          this.photos = result.data

          this.paginationData = {
            currentPage: result.current_page,
            lastPage: result.last_page,
            total: result.total,
          }
        })
        .catch((err) => {
          this.$toasted.show(err.body.mensagem, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearInputs() {
      this.schema = ''
      this.initialDate = ''
      this.finalDate = ''
      this.aluno = ''
      this.device = ''
      this.agrupamento = ''
    },
    getFantasyName(schema) {
      return this.schemaOptions.find(cfc => cfc.value === schema).text
    },
    async handleExport() {
      if (!this.validateInputs()) {
        return
      }

      this.loadingActions = true

      const params = {
        periodo: [this.initialDate, this.finalDate],
      }

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/export/planilha/turmas-teoricas/fotos-monitoradas`, {
        params,
      })
        .then((res) => {
          _export.downloadCSV(res.body.dados, 'alunos-monitorados')
        })
        .catch((err) => {
          this.$toasted.show(err.body.mensagem, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loadingActions = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.loading {
  width: 60vw;
  display: flex;
  justify-content: center;
  align-items: center;
}

.relatorio-form {
  width: 60vw;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  .inputs {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    .inputs-row {
      display: flex;
      flex-wrap: wrap;
      gap: 1.5rem;

      .input-full {
        flex: 1;
      }
    }
  }

  .buttons {
    align-self: flex-end;

    display: flex;
    gap: 0.5rem;
  }
}

.result-container {
  width: 60vw;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .actions {
    display: flex;
    align-items: flex-end;
    gap: 1rem;
  }

  .table-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .pagination-container {
      align-self: flex-end;
    }
  }
}
</style>